var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checklistItem"},[_c('div',[_c('small',[_vm._v(_vm._s(_vm.fileName))])]),_vm._v(" "),_c('sx-icon',{attrs:{"name":"remove","size":20}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }